<template>
  <v-row>
    <v-col cols="12">
      <CommonTable
        list-getter="projectMeteringStore/sourceAdapterMessageStore/getList"
        :headers="headers"
        :slots="slots"
        :actions="actions"
        resource="source-adapter-messages"
        @updated="updateList"
        :loading.sync="loading"
      ></CommonTable>
      <Paginator
        page-getter="projectMeteringStore/sourceAdapterMessageStore/getPage"
      ></Paginator>
    </v-col>
  </v-row>
</template>

<script>
import Paginator from "../../../common/tables/Paginator";
import CommonTable from "../../../common/tables/CommonTable";
import { projectPermissions } from "../../../mixins/projects/projectPermissions";

export default {
  name: "MessagesSourceAdapter",
  components: {
    Paginator,
    CommonTable
  },
  mixins: [projectPermissions],
  data: function() {
    return {
      headers: [
        {
          text: this.$t("source-adapter-messages.receive-time"),
          align: "left",
          value: "receive_time"
        },
        {
          text: this.$t("source-adapter-messages.sender"),
          value: "sender"
        },
        {
          text: this.$t("source-adapter-messages.event"),
          value: "event"
        },
        {
          text: this.$t("source-adapter-messages.method"),
          value: "method"
        }
      ],
      actions: [],

      loading: false
    };
  },
  computed: {
    getParams() {
      return ` ${this.$route.query.page}
                ${this.$route.query.limit_items}
                ${this.$route.query.orders}
                ${this.$route.query.search}
                `;
    },
    project: function() {
      return this.$store.getters["projectStore/getCurrentItem"];
    },
    slots: function() {
      let project = this.project;
      return [
        {
          name: "receive_time",
          type: "date",
          to: "source-adapter-message",
          dateTimeZone: project.timezone,
          linkParams: {
            id: "id"
          }
        }
      ];
    }
  },

  watch: {
    getParams: function() {
      this.updateList();
    }
  },
  methods: {
    updateList() {
      this.loading = true;
      let params = this.formingParams();
      this.$store.dispatch(
        "projectMeteringStore/sourceAdapterMessageStore/getList",
        {
          params,
          onSuccess: () => {
            this.loading = false;
          }
        }
      );
    },
    formingParams() {
      return {
        project_id: this.$route.params.project_id,
        page: this.$route.query.page,
        limit: this.$route.query.limit_items,
        orders: this.$route.query.orders,
        filters: {
          source_adapter: this.$route.params.id
        }
      };
    }
  },
  mounted() {
    this.updateList();
  }
};
</script>

<style scoped></style>
